import "./pLicenseAgreement/pLicenseAgreement.sass";

import { pLicenseAgreementDirective } from './pLicenseAgreement/pLicenseAgreement.directive';

export default angular.module('frontend.licenseAgreement', ["frontend.api", "frontend.auth", "frontend.theme"])
  .directive('pLicenseAgreement', pLicenseAgreementDirective);
